import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramadoCostoDirecto';
import mixAvanceFinanciero from '@/helpers/calculos/mixAvanceFinancieroCostoDirecto';

export default {
  mixins: [mixAvanceProgramado, mixAvanceFinanciero],
  data() {
    return {
      montoPrograma: 0,
      rango: [],
      fechaAl: '',
      numeroEstimacionAl: 0,
      mesesNombres: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago',
        'Sep', 'Oct', 'Nov', 'Dic',
      ],
    };
  },

  computed: {

    mixCalcularPuntosGrafica() {
      if (!this.programasobra || this.mixProgramasObras.length <= 0) return [];

      // Destructurar el primer progama
      let [{ programa }] = this.mixProgramasObras;

      this.montoPrograma = this.sumarMontoAcumulado(programa);
      this.fechaAl = this.estimacion.fechaAl ? new Date(`${this.estimacion.fechaAl} 00:00:0`) : new Date('2000-01-01 00:00:0');

      // Ordernar el programa por fecha de inicio
      programa = programa.slice().sort((a, b) => new Date(`${a.fechaInicio} 00:00:0`) - new Date(`${b.fechaInicio} 00:00:0`));
      let ultimoDiaMes = new Date();

      this.numeroEstimacionAl = this.estimacion.numero ? this.estimacion.numero : 0;
      this.fechaAl = this.estimacion.fechaAl ? new Date(`${this.estimacion.fechaAl} 00:00:0`) : new Date('2000-01-01 00:00:0');
      // CALCULA LOS IMPORTES FINANCIEROS PARA CADA MES
      this.getImportesPorMes();

      // *****  PUNTOS DEL RANGO DE LA GRAFICA - EJE X ******

      // Asigna como última fecha para el eje X el mes de termino del programa
      let ultimaFechaProgramaOEstimacion = programa[programa.length - 1].fechaTermino;
      // Evalua si la fechaAl de la estimación es mayor a la anterior, reasigna esta como última
      if (this.estimacion.fechaAl > ultimaFechaProgramaOEstimacion) {
        ultimaFechaProgramaOEstimacion = this.estimacion.fechaAl;
      }
      // Obtiene los puntos del rango
      let rango = this.rangoFechas(programa[0].fechaInicio,
        ultimaFechaProgramaOEstimacion,
        { month: '2-digit', year: 'numeric' });
      const rangoLetra = ['', ...rango.map((r) => `${this.mesesNombres[r.split('/')[0] - 1]}-${r.split('/')[1].substring(2, 4)}`)];

      // Calcula los importes programados para cada punto
      const importeProgramado = [0, ...rango.map((r) => {
        ultimoDiaMes = new Date(r.split('/')[1], r.split('/')[0], 0);
        return (this.mixCalcularPrograma(`${ultimoDiaMes.getFullYear()}-${ultimoDiaMes.getMonth() + 1}-${ultimoDiaMes.getDate()}`, true).importe || 0);
      })];
      // Calcula los porcentajes de importes programados para cada punto
      const importeProgramadoPorcentaje = [0, ...rango.map((r) => {
        ultimoDiaMes = new Date(r.split('/')[1], r.split('/')[0], 0);
        return (this.mixCalcularPrograma(`${ultimoDiaMes.getFullYear()}-${ultimoDiaMes.getMonth() + 1}-${ultimoDiaMes.getDate()}`, true).porcentaje || 0);
      })];
      /* Calcula los importes financieros para cada punto,
          los busca en el array de objetos de importesDelMes */
      let importeFinanciero = rango.map((r) => {
        const mes = new Date(`${r.split('/')[1]}-${r.split('/')[0]}-01 00:00:0`);
        ultimoDiaMes = new Date(r.split('/')[1], r.split('/')[0], 0);
        const fechaTerminoMes = new Date(this.fechaAl.getFullYear(),
          this.fechaAl.getMonth() + 1, 0);
        if (fechaTerminoMes.getTime() < ultimoDiaMes.getTime()) { return -1; }
        const importes = this.importesDelMes.find((i) => {
          if (i.fechaInicio.getTime() === mes.getTime()) { return i.importe; } return 0;
        });
        if (importes) { return importes.importe; } return 0;
      });

      let total = 0;
      importeFinanciero = [...importeFinanciero.map(
        (i) => {
          if (i === -1) { return false; }
          total += i;
          return this.$numberRound(total);
        },
      )];
      importeFinanciero = importeFinanciero.filter((i) => i !== false);
      /* Calcula los  porcentajes de importes financieros para cada punto,
          los extrae del array de importeFinanciero */
      const importeFinancieroPorcentaje = [...importeFinanciero.map(
        (i) => this.$numberRound((i / this.montoPrograma) * 100),
      )];

      rango = [0, ...rango];
      /*
      console.log('FINALES -->', this.montoPrograma, rango, rangoLetra,
        importeProgramado,
        importeProgramadoPorcentaje,
        importeFinanciero,
        importeFinancieroPorcentaje);
      */
      // Se valida si la estimacion elegida es finiquito el valor en grafica % se va a 100%
      if (this.estimacion.esEstimacionFiniquito && importeFinancieroPorcentaje.length > 0) {
        importeFinancieroPorcentaje[importeFinancieroPorcentaje.length - 1] = 100;
      }
      return {
        puntos: rango,
        puntosLetra: rangoLetra,
        programado: importeProgramado,
        programadoPorcentaje: importeProgramadoPorcentaje,
        financiero: [0, ...importeFinanciero],
        financieroPorcentaje: [0, ...importeFinancieroPorcentaje],
        financieroTabla: ['-', ...importeFinanciero],
        financieroPorcentajeTabla: ['-', ...importeFinancieroPorcentaje],
      };
    },
  },
};
